module.exports = __webpack_public_path__ + "static/media/SaveButton.8902e888.png";